import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ButtonComponent } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { DocumentLinkUploadComponent } from './document-upload/document-link-upload/document-link-upload.component';
import { IntakeDocumentUploadComponents } from './document-upload/intake-document-upload/intake-document-upload.component';
import {
  ButtonOptions,
  INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES,
  UploaderOptions,
} from './document-settings';
import { IntakeOppertunitySubmissionStatus } from '../../../constants/intake-submission-status.enum';
import {
  IntakeDocumentStatusDropdownModel,
  IntakeDocumentTableModel,
  IntakeDocumentTypeDropdownModel,
} from '../../../../common/models/intake-document-table.model';
import { PermissionsObj } from '../../../../common/models/common-models';
import { SubmissionService } from '../../../../http/intake/submission.service';
import { OpportunityDetailsNavModel } from '../../../../common/models/opportunity-details.model';
import { IntakeConstant } from '../../../constants/intake.constant';
import { ProgressIndicatorService } from '../../../../common/services/progress-indicator.service';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { CommonHelperService } from '../../../../common/services/common-helper.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  DocumentStatus,
  IntakeDocumentStatusIdMapper,
} from '../../../constants/document-status.enum';
import { SharedConstant } from '../../../../common/constants/shared.constant';
import { IntakeDocumentSubmissionTypeCode } from '../../../constants/intake-submission-type.enum';
import {
  excludeAdditionalRMReviewRqdFromDocStatus,
  excludeDraftForReviewFromDocStatus,
} from '../../../common/intake.util';
import { RoleService } from '../../../../http/intake/role.service';
import { Subject, takeUntil } from 'rxjs';
import {
  IntakeDocumentType,
  IntakeDocumentTypeToIdMapper,
} from '../../../constants/intake-document-type.enum';
@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrl: './document.component.less',
})
export class DocumentComponent implements OnInit {
  _EMPTY = IntakeConstant.EMPTY_SPACE;
  @Input() tableId!: number;
  @Input() submissionTypeId: number = 0;
  @Input() submissionStatusId: number = 0;
  @Input() submissionId: number = 0;
  @Input() progressiveStatus: boolean | null = null;
  @Input() submissionTypeCode: string | undefined = this._EMPTY;
  @Input() submissionStatus: string | undefined = this._EMPTY;
  @Input() isDraftForSelfReview: boolean = false;
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() showDocumentTable: boolean = true;
  @Input() showDragNDropArea: boolean = true;
  @Input() showAttachDocumentBtn: boolean = true;
  @Input() showAddLinkBtn: boolean = true;
  @Input() showToggleBtn: boolean = true;
  @Input() toggleOpen: boolean = false;
  @Input() filterDocArr: string[] = [];
  @Input() isDocSectionEditable: boolean = true;
  @Input() showArchiveColumn: boolean = false;
  @Input() opportunityDocs!: OpportunityDetailsNavModel[];
  @Input() submissionTypeSubId: number | null | undefined = null;
  @Input() rmReviewedGuidanceNoteHeader: string = IntakeConstant.EMPTY_SPACE;
  @Input() rmReviewedGuidanceNoteBody: string = IntakeConstant.EMPTY_SPACE;
  @Input() selfReviewEligibilityStatus: string | undefined =
    IntakeConstant.EMPTY_SPACE;
  @Input() optOutOfSelfReview: string | null | undefined =
    IntakeConstant.EMPTY_SPACE;
  @Input() selfReviewEligibilityStatusId: number | string | undefined;
  @Input() optOutSelfReviewDate: string | null = null;
  @Input() uploadAreaBtnLabel: string = 'Select file(s)';
  @Input() currentStatusChangeDate: string | null = null;
  @Input() otherSubmissionSubType!: string;

  @Output() documentTableData: EventEmitter<IntakeDocumentTableModel[]> =
    new EventEmitter<IntakeDocumentTableModel[]>();

  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  loggedInUserRoles: string[] = [];
  documentTypeOptions: SelectItemOptions[] = [];
  documentStatusOptions: SelectItemOptions[] = [];

  constructor(
    private readonly modalService: ModalService,
    private readonly submissionService: SubmissionService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly commonHelperService: CommonHelperService,
    private readonly roleService: RoleService
  ) {}

  options = ButtonOptions;
  uploadAreaOptions = UploaderOptions;
  isSubmissionStatusRMorSelfReviewed: boolean = true;
  documentTableDataCurrently: IntakeDocumentTableModel[] = [];
  ngOnInit(): void {
    this.roleService.currentUserRole$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: string[]) => {
          this.loggedInUserRoles = response;
        },
      });

    // TODO: Check if user roles are fetched on time, used in typedropdown filter
    this.getDocumentTypeDropdownData();
    this.getDocumentStatusDropdownData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changesSubmissionTypeSubId = changes?.['submissionTypeSubId'];
    const changesSubmissionTypeId = changes?.['submissionTypeId'];
    const changesSubmissionStatusId = changes?.['submissionStatusId'];
    if (
      changes['submissionTypeSubId'] &&
      changes['submissionTypeSubId'].currentValue
    ) {
      this.submissionTypeSubId = changes['submissionTypeSubId'].currentValue;
    }
    if (
      (!changesSubmissionTypeSubId?.isFirstChange() &&
        changesSubmissionTypeSubId?.currentValue !=
          changesSubmissionTypeSubId?.previousValue) ||
      (!changesSubmissionTypeId?.isFirstChange() &&
        changesSubmissionTypeId?.currentValue !=
          changesSubmissionTypeId?.previousValue) ||
      (!changesSubmissionStatusId?.isFirstChange() &&
        changesSubmissionStatusId?.currentValue !=
          changesSubmissionStatusId?.previousValue)
    ) {
      this.getDocumentTypeDropdownData();
      this.getDocumentStatusDropdownData();
    }
  }

  triggerDocumentTableDataApi(): void {
    this.submissionService.triggerDocumentReload({
      sourceTableId: this.tableId,
      triggerScope: 'all',
    });
  }

  openDocumentLinkModel(modalBtn?: any): void {
    const modalRef = this.modalService.open(DocumentLinkUploadComponent, {
      documentInitiatedDetails: {
        submissionId: this.submissionId,
        moduleName: 'Intake',
        submissionStatusId: this.submissionStatusId,
        submissionTypeId: this.submissionTypeId,
        type: this.submissionTypeCode,
        submissionTypeCode: this.submissionTypeCode,
        submissionStatus: this.submissionStatus,
        submissionTypeSubId: this.submissionTypeSubId,
      },
      rmReviewedGuidanceNoteHeader: this.rmReviewedGuidanceNoteHeader,
      rmReviewedGuidanceNoteBody: this.rmReviewedGuidanceNoteBody,
      documentTypeOptions: this.documentTypeOptions,
      setDocumentStatusOptions: this.documentStatusOptions,
    });
    modalRef.onClosed().subscribe(() => {
      this.triggerDocumentTableDataApi();
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  openUploadModel(event: any, modalBtn?: ButtonComponent): void {
    this.removeBodyOverflow();
    const modalRef = this.modalService.open(IntakeDocumentUploadComponents, {
      isFooter: true,
      size: 'lg',
      isInverse: false,
      documentTableDataCurrently: this.documentTableDataCurrently,
      documentInitiatedDetails: {
        moduleName: 'Intake',
        submissionStatusId: this.submissionStatusId,
        submissionTypeId: this.submissionTypeId,
        submissionId: this.submissionId,
        documentUploadCount: 1,
        file: event,
        type: this.submissionTypeCode,
        submissionTypeCode: this.submissionTypeCode,
        submissionStatus: this.submissionStatus,
        submissionTypeSubId: this.submissionTypeSubId,
      },
      permissionObj: this.permissionObj,
      rmReviewedGuidanceNoteHeader: this.rmReviewedGuidanceNoteHeader,
      rmReviewedGuidanceNoteBody: this.rmReviewedGuidanceNoteBody,
      selfReviewEligibilityStatus: this.selfReviewEligibilityStatus,
      optOutOfSelfReview: this.optOutOfSelfReview,
      documentTypeOptions: this.documentTypeOptions,
      setDocumentStatusOptions: this.documentStatusOptions,
    });

    modalRef.onClosed().subscribe(() => {
      this.triggerDocumentTableDataApi();
      event.splice(0, event.length); // Clears the document uploaded
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  hideLinkButton(): boolean {
    return (
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT
    );
  }

  removeBodyOverflow(): void {
    document.body.style.overflowY = 'hidden';
  }

  documentTableDataValue(allDocFromAPI: IntakeDocumentTableModel[]): void {
    this.documentTableDataCurrently = allDocFromAPI;
    this.documentTableData.emit(allDocFromAPI);
    this.isSubmissionStatusRMorSelfReviewed =
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT;
  }

  get shouldShowUploader(): boolean {
    return (
      this.permissionObj['Intake_Submission_DocumentDragAndDrop_Visible'] &&
      this.showDragNDropArea
    );
  }

  get isAddLinkButtonVisible(): boolean {
    return (
      this.permissionObj['Intake_Submission_AddDocumentLink_Visible'] &&
      (!this.isDraftForSelfReview ||
        (this.selfReviewEligibilityStatusId == 1 /*Yes*/ &&
          this.optOutSelfReviewDate == null)) &&
      this.showAddLinkBtn
    );
  }

  getDocumentTypeDropdownData(): void {
    this.submissionService
      .getDocumentTypeDropdown(
        this.submissionTypeId,
        this.submissionTypeSubId ?? undefined
      )
      .subscribe({
        next: (result: IntakeDocumentTypeDropdownModel[]) => {
          const convertedArray = result?.map(
            (item: IntakeDocumentTypeDropdownModel): SelectItemOptions => ({
              value: item.documentTypeId,
              heading: item.documentTypeName,
            })
          );
          this.documentTypeOptions = convertedArray;
          if (
            this.submissionTypeCode === IntakeDocumentSubmissionTypeCode.OTH
          ) {
            const subContractAgreementId: number =
              IntakeDocumentTypeToIdMapper[
                IntakeDocumentType.SubcontractorAgreement
              ];
            if (
              this.submissionTypeSubId ===
              3 /*Subcontractor Agreement (Subcon) */
            ) {
              // Subcontractor Agreement is only available for submissionType OTH
              this.documentTypeOptions =
                this.commonHelperService.prioritizeDocumentTypeById(
                  subContractAgreementId /*Subcontractor Agreement */,
                  this.documentTypeOptions
                );
            } else {
              this.documentTypeOptions = this.documentTypeOptions.filter(
                (item) =>
                  item.value !==
                  subContractAgreementId /*Subcontractor Agreement */
              );
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('Error fetching document type', err);
        },
      });
  }

  getDocumentStatusDropdownData(): void {
    this.submissionService
      .getDocumentStatusDropdown(this.submissionStatusId, this.submissionTypeId)
      .subscribe({
        next: (result: IntakeDocumentStatusDropdownModel[]) => {
          let convertedArray =
            result?.map(
              (item: IntakeDocumentStatusDropdownModel): SelectItemOptions => ({
                value: item.documentStatusId,
                heading: item.documentStatusName,
              })
            ) ?? [];

          convertedArray = excludeDraftForReviewFromDocStatus(
            this.loggedInUserRoles,
            convertedArray
          );
          convertedArray = excludeAdditionalRMReviewRqdFromDocStatus(
            this.loggedInUserRoles,
            convertedArray,
            this.submissionStatus ?? ''
          );
          if (
            !this.loggedInUserRoles.some((role) =>
              INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES.includes(role)
            )
          ) {
            convertedArray = convertedArray.filter(
              (item: SelectItemOptions) =>
                item.value !==
                IntakeDocumentStatusIdMapper.get(
                  DocumentStatus.InternalRMReviewed
                )
            );
          }
          if (
            this.submissionStatus === IntakeOppertunitySubmissionStatus.DRAFT &&
            (this.submissionTypeCode as IntakeDocumentSubmissionTypeCode) !=
              IntakeDocumentSubmissionTypeCode.CO
          ) {
            convertedArray = convertedArray.filter(
              (item: SelectItemOptions) =>
                item.value !==
                IntakeDocumentStatusIdMapper.get(
                  DocumentStatus.FinalArchiveReadyVersion
                )
            );
          }

          if (
            this.submissionStatus === IntakeOppertunitySubmissionStatus.DRAFT ||
            this.submissionStatus ===
              IntakeOppertunitySubmissionStatus.RETURN_FOR_REWORK
          ) {
            convertedArray = convertedArray.filter(
              (item: SelectItemOptions) => {
                if (
                  this.optOutOfSelfReview !== null &&
                  this.optOutOfSelfReview !== undefined
                ) {
                  return (
                    item.value !==
                    IntakeDocumentStatusIdMapper.get(
                      DocumentStatus.SelfReviewed
                    )
                  );
                } else if (
                  this.selfReviewEligibilityStatus ===
                  SharedConstant.YES_CAPITALCASE
                ) {
                  return (
                    item.value !==
                    IntakeDocumentStatusIdMapper.get(DocumentStatus.Draft)
                  );
                } else if (
                  this.selfReviewEligibilityStatus ===
                    IntakeConstant.SELF_REVIEW_PENDING ||
                  this.selfReviewEligibilityStatus ===
                    SharedConstant.NO_CAPITALCASE
                ) {
                  return (
                    item.value !==
                    IntakeDocumentStatusIdMapper.get(
                      DocumentStatus.SelfReviewed
                    )
                  );
                }
                return true;
              }
            );
          }

          const reorderPriority = [
            IntakeDocumentStatusIdMapper.get(DocumentStatus.InternalRMReviewed),
            IntakeDocumentStatusIdMapper.get(DocumentStatus.RMReviewed),
          ];

          this.documentStatusOptions = convertedArray.sort((a, b) => {
            const indexA = reorderPriority.indexOf(a.value);
            const indexB = reorderPriority.indexOf(b.value);

            if (indexA === -1 && indexB === -1) {
              return 0;
            }
            if (indexA === -1) {
              return 1;
            }
            if (indexB === -1) {
              return -1;
            }
            return indexA - indexB;
          });
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('Error fetching document type', err);
        },
      });
  }

  ngOnDestroy(): void {}
}
